import React, { useCallback, useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { LoadingContext } from 'gw-capability-policy-react';
import metadata from './CustomPaymentScheduleAndHistoryPage.metadata.json5';
import styles from './CustomPaymentScheduleAndHistoryPage.module.scss';
import messages from './CustomPaymentScheduleAndHistoryPage.messages';
import CustomPaymentHistory from '../CustomPaymentHistory/CustomPaymentHistory';
import CustomPaymentSchedule from '../CustomPaymentSchedule/CustomPaymentSchedule';
import { CustomIconUtil } from 'gw-portals-util-js';
import { Image } from '@jutro/components';

//1781447 - Payment Schedule and History Page Optimization
function CustomPaymentScheduleAndHistoryPage(props) {
    
    const { authHeader, history } = props;
    //1852420 - Payment Schedule and History page - Page refresh gives 'Something went wrong' error
    const paySummaryState = sessionStorage.getItem('paySummaryState');
    const parsedPaySummaryState = JSON.parse(paySummaryState);
    const { policyData, activeTab, invoiceStreamId } = history.location.state || parsedPaySummaryState || {};
    const { AccountBillingDetailsService: BillingService } = useDependencies('AccountBillingDetailsService');
    const loader = useContext(LoadingContext);
    const [invoiceStreamDetails, setInvoiceStreamDetails] = useState();    
    
    useEffect(() => {
        loader.setLoading(true);
        BillingService.getInvoiceStreamDetails(invoiceStreamId, authHeader)
            .then((response) => {
                setInvoiceStreamDetails(response);
            })
            .finally(() => {
                loader.setLoading(false)
            });            
    }, [BillingService]);         

    function backToTop() {
        window.scrollTo(0, 0);
    }

    if (_.isEmpty(invoiceStreamDetails)) {
        return <Image className={styles.spinner} src={CustomIconUtil.getLogoSrc('rotating-circle-blue_128.gif')} showLoader={false} />;
    }

    const overrideProps = {
        backToPolicyLink: {
            className: 'back-policy-detail-action',
            to: '/home'
        },
        paymentScheduleSection: {
            selectedPolicyInvoices: invoiceStreamDetails,
            showPaymentSchedule: policyData.periods[0].canMakeAPayment_Ext && policyData.periods[0].status !== 'Expired' && policyData.periods[0].status !== 'Canceled'
        },
        tabsStory: {
            className: (policyData.periods[0].billingMethod_Ext === 'Agency Bill') ? 'policyCardTabStory agencyBillDetails' : 'policyCardTabStory',
            activeTab: activeTab
        },
        agencyBillTab: {
            visible: policyData.periods[0].billingMethod_Ext === 'Agency Bill'
        },
        paymentHistorySection: {
            selectedPaymentHistory: invoiceStreamDetails,
            selectedPolicy: policyData.periods[0]
        },
        backToTopLink: {
            className: 'back-to-top-action',
            onClick: backToTop
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            custompaymentschedule: CustomPaymentSchedule,
            custompaymenthistory: CustomPaymentHistory
        },
    };

    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

CustomPaymentScheduleAndHistoryPage.propTypes = {
    authHeader: PropTypes.shape({}).isRequired
};

export default withAuthenticationContext(withRouter(CustomPaymentScheduleAndHistoryPage));